@if (reply) {
    <div class="ticket-message reply position-relative mb-2" id="replies-block">
        @if (!commonDataService.isOneTime && reply.noteIds?.length) {
            <app-note-link-line [noteIds]="reply.noteIds" class="reference-line" [ticket]="ticket"></app-note-link-line>
        }

        @if (reply.reminder) {
            <div class="reminder-alert" [class.reminder-alert_staff]="reply.isByTeam">
                <app-reply-reminder-alert
                    [reminder]="reply.reminder"
                    (removeReminderClick)="onRemoveReminderClick()"></app-reply-reminder-alert>
            </div>
        }

        @if (reply.type === messageThreadElementTypeEnum.reply) {
            <div
                class="chat-reply"
                [ngClass]="{
                    'staff-reply': reply.isByTeam,
                    'user-reply': !reply.isByTeam,
                }">
                <sb-user-avatar
                    class="pointer"
                    (click)="parent.rightPanelService.open(rightPanelTypeEnum.user, { user: reply.author })"
                    [user]="reply.author"
                    [isNeedTooltip]="false"
                    [withLabel]="true">
                </sb-user-avatar>
                <div class="reply-body">
                    <a
                        (click)="parent.rightPanelService.open(rightPanelTypeEnum.user, { user: reply.author })"
                        class="reply-user text-break">
                        {{ reply.author.name || reply.author.email }}
                    </a>
                    <div class="reply-wrapper">
                        @if (!isReplyMessageEmpty) {
                            <div class="position-relative reply-text">
                                <div class="reply-text-content position-relative">
                                    @if (!reply.isDeleted) {
                                        <span
                                            class="break-word message-html-content"
                                            sbInlineImagePreview
                                            appInlineImageLimitWidth
                                            [innerHTML]="reply.message | prepareMessage | replaceEmojis: true">
                                        </span>
                                        @if (reply.isEdited) {
                                            <small class="text-light"> ({{ 'edited' | translate }})</small>
                                        }
                                    } @else {
                                        <small class="text-light" translate>This message was deleted.</small>
                                    }
                                    @if (reply.reactions?.length) {
                                        <app-reactions
                                            [isSingleEmoji]="true"
                                            [reactions]="reply.reactions"
                                            [tooltipTextType]="reactionTooltipTextType.senders"
                                            class="reply-reactions-wrapper">
                                        </app-reactions>
                                    }
                                    @if (reply.isByTeam) {
                                        <div class="message-status">
                                            @if (reply.isDelivered) {
                                                <sb-inline-svg
                                                    class="icon"
                                                    [url]="
                                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Check icon.svg'
                                                    ">
                                                </sb-inline-svg>
                                            }
                                            @if (reply.isRead) {
                                                <sb-inline-svg
                                                    class="icon read"
                                                    [url]="
                                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Check icon.svg'
                                                    ">
                                                </sb-inline-svg>
                                            }
                                        </div>
                                    }
                                </div>
                                @if (!commonDataService.isOneTime) {
                                    <app-reply-chat-menu
                                        class="position-absolute"
                                        [parent]="parent"
                                        [reply]="reply"
                                        [ticket]="ticket"
                                        (remindClick)="onRemindClick($event)"
                                        (pickDateAndTimeClick)="openReminderModal()"
                                        (removeReminderClick)="onRemoveReminderClick()">
                                    </app-reply-chat-menu>
                                }
                            </div>
                        }

                        @if (
                            (!commonDataService.isOneTime && isReplyMessageEmpty) ||
                            (reply.attachments | filterContentAttachments: true : reply.attachments?.length).length ||
                            (reply.attachments | filterContentAttachments: false : reply.attachments?.length).length
                        ) {
                            <div
                                class="d-flex flex-wrap mt-2"
                                [ngClass]="{
                                    'reply-without-message': isReplyMessageEmpty,
                                    'justify-content-end': reply.isByTeam,
                                    'menu-container--with-content-attachments': (
                                        reply.attachments | filterContentAttachments: true : reply.attachments?.length
                                    ).length,
                                }">
                                @if (!commonDataService.isOneTime && isReplyMessageEmpty) {
                                    <app-reply-chat-menu
                                        [parent]="parent"
                                        [reply]="reply"
                                        [ticket]="ticket"
                                        (remindClick)="onRemindClick($event)"
                                        (pickDateAndTimeClick)="openReminderModal()"
                                        (removeReminderClick)="onRemoveReminderClick()">
                                    </app-reply-chat-menu>
                                }
                                @if (
                                    (reply.attachments | filterContentAttachments: true : reply.attachments?.length)
                                        .length
                                ) {
                                    <div class="w-100 menu-position-for-content-attachment">
                                        @for (
                                            attachment of reply.attachments
                                                | filterContentAttachments: true : reply.attachments?.length;
                                            track attachment;
                                            let attachmentsCount = $count
                                        ) {
                                            <sb-file-view
                                                [isFilePreviewInModal]="true"
                                                [attachment]="attachment"
                                                [permalink]="ticket.permalink"
                                                [canBeShared]="
                                                    !commonDataService.isOneTime &&
                                                    !commonDataService.user.isReadOnly &&
                                                    isInboxElementVisible(
                                                        commonDataService.customerSettings?.inboxElementsVisibility
                                                            ?.ticketHeader?.forwardAction
                                                    )
                                                "
                                                (forwardFile)="
                                                    forwardMessageService.openForwardForm(
                                                        { message: {}, attachments: [$event] },
                                                        forwardEntityTypeEnum.attachment,
                                                        ticket
                                                    )
                                                "
                                                class="mb-2"
                                                [ngClass]="{
                                                    'me-2': !reply.isByTeam && attachmentsCount > 1,
                                                    'ms-2': reply.isByTeam && attachmentsCount > 1,
                                                }"
                                                [reply]="reply">
                                            </sb-file-view>
                                        }
                                        <div class="clearfix"></div>
                                    </div>
                                }

                                @for (
                                    attachment of reply.attachments
                                        | filterContentAttachments: false : reply.attachments?.length;
                                    track attachment;
                                    let idx = $index;
                                    let isLast = $last;
                                    let isFirst = $first
                                ) {
                                    <sb-file-preview
                                        class="file-container"
                                        [attachment]="attachment"
                                        [permalink]="ticket.permalink"
                                        [reply]="reply"
                                        [ngClass]="{ 'me-0': isLast, 'ms-0': isReplyMessageEmpty && isFirst }"
                                        [attachments]="
                                            reply.attachments
                                                | filterContentAttachments: false : reply.attachments?.length
                                        "
                                        [fileIndex]="idx"
                                        [canBeShared]="
                                            !commonDataService.isOneTime &&
                                            !commonDataService.user.isReadOnly &&
                                            isInboxElementVisible(
                                                commonDataService.customerSettings?.inboxElementsVisibility
                                                    ?.ticketHeader?.forwardAction
                                            )
                                        "
                                        (forwardFile)="
                                            forwardMessageService.openForwardForm(
                                                { message: {}, attachments: [$event] },
                                                forwardEntityTypeEnum.attachment,
                                                ticket
                                            )
                                        ">
                                    </sb-file-preview>
                                }
                            </div>
                        }
                    </div>
                    <small
                        class="d-flex align-items-center flex-wrap mt-2"
                        [class.justify-content-end]="reply.isByTeam">
                        <span
                            class="time text-light item-with-dot"
                            [tooltip]="replyCreationTimeTooltipText"
                            #replyTimeTooltipOnDate="bs-tooltip"
                            triggers=""
                            (mouseenter)="showTimeTooltip(replyTimeTooltipOnDate)"
                            (mouseleave)="hideTimeTooltip(replyTimeTooltipOnDate)">
                            {{ reply.creationTime | timeAgo }}
                        </span>

                        @if (reply.tags?.length) {
                            <app-tags [ticketId]="ticket.id" [tags]="reply.tags" class="item-with-dot"></app-tags>
                        }

                        @if (reply.msSentiment && reply.msSentiment.value) {
                            <app-ms-sentiment
                                class="item-with-dot"
                                [sentimentScore]="reply.msSentiment.score"
                                [sentimentValue]="reply.msSentiment.value">
                            </app-ms-sentiment>
                        }
                    </small>
                </div>
            </div>
        }
        @if (reply.type === messageThreadElementTypeEnum.satisfaction) {
            <div class="text-end satisfaction-block">
                @if (reply.isSatisfied) {
                    <span>
                        <span translate>The customer rated this conversation as positive – good job!</span>
                        <sb-inline-svg
                            class="icon icon-thumbs-up ms-1 vertical-align-middle"
                            aria-label="My icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Thumbs up icon.svg'">
                        </sb-inline-svg>
                    </span>
                } @else {
                    <span translate>Hmm, the customer rated this conversation as negative</span>
                    <sb-inline-svg
                        class="icon icon-thumbs-down ms-1 vertical-align-middle"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Thumbs up icon.svg'">
                    </sb-inline-svg>
                }
                @if (reply.text) {
                    <div>
                        <span translate>Comment:</span>&nbsp;
                        <span
                            class="text-break"
                            [innerHTML]="reply.text | newLine | safeHtml | replaceEmojis: false"></span>
                    </div>
                }
            </div>
        }
        <div class="clearfix"></div>

        @if (reply.type === messageThreadElementTypeEnum.survey) {
            <app-thread-survey-result [threadElement]="reply" class="survey-block"></app-thread-survey-result>
        }
        @if (false && reply.type === messageThreadElementTypeEnum.sessionAuthentication) {
            <app-session-authentication-event [event]="reply"></app-session-authentication-event>
        }
    </div>
}
